import clsx from "clsx";
import { Label } from "components";
import { InputHTMLAttributes } from "react";

import { Constants } from "appConstants";
import { IcoInfoCircle } from "assets/icons";
import "./styles.scss";

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
	label: string;
	error?: string | Array<string>;
	className?: string;
	touched?: boolean;
	Icon?: JSX.Element;
	hideOptional?: boolean;
	uniqueOption?: boolean;
};

export default function Input({
	label,
	placeholder,
	type,
	name,
	value,
	required,
	disabled,
	error,
	touched,
	onChange,
	onBlur,
	Icon,
	hideOptional,
	className = "",
	uniqueOption = false,
	...args
}: InputProps) {
	return (
		<div
			className={clsx(`input-component--wrapper ${className}`, {
				disabled,
				error: error && touched
			})}
		>
			<Label
				isRequired={!!required}
				hideOptional={hideOptional}
				className="flex gap-2"
			>
				{label}
				{uniqueOption && (
					<div className="icon-info-circle-container">
						<IcoInfoCircle color="#1D1D1D" />
						<div className="tooltip">
							{Constants.strings.pages.term.uniqueOption}
						</div>
					</div>
				)}
			</Label>
			<div className={clsx("input-component", { disabled })}>
				<input
					type={type}
					name={name}
					value={value}
					placeholder={placeholder}
					onChange={onChange}
					onBlur={onBlur}
					disabled={disabled}
					required={required}
					{...args}
				/>
				{Icon}
			</div>
			{error && touched && (
				<div className="white-space--pre-line mt-1 my-0 error-text">
					{Array.isArray(error) ? error.join("\n") : error}
				</div>
			)}
		</div>
	);
}
